import {NgModule} from '@angular/core';
import {InterceptorService} from './common/interceptor.service';
import {TitleService} from './common/title.service';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {GuardService} from './common/guard.service';
import { ObjectObvervableService } from './common/objectObservable.service';

@NgModule({
  imports: [],
  declarations: [],
  providers: [
    TitleService,
    ObjectObvervableService,
    GuardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
  ],
  exports: []
})
export class ServicesModule {
}



// WEBPACK FOOTER //
// ./src/app/services/services.module.ts